import { InjectionToken } from '@angular/core';

import { environment } from '../../../environments/environment';
import { LearningHubConfig, LearningHubLanguage } from './learning-hub.models';

export const LEARNING_HUB_LANGUAGES: LearningHubLanguage[] = ['es', 'en', 'pt'];
export const LEARNING_HUB_DEFAULT_LANGUAGE: LearningHubLanguage = 'es';

/** Load status of a learning-hub view. */
export const LEARNING_HUB_STATUS = {
  LOADING: 'loading',
  READY: 'ready',
  NOT_FOUND: 'not-found',
  ERROR: 'error'
} as const;

export type LearningHubStatus = (typeof LEARNING_HUB_STATUS)[keyof typeof LEARNING_HUB_STATUS];

/** Placeholders written by scripts/learning-hub/convert-wxr.py into the article HTML. */
export const LEARNING_HUB_MEDIA_PREFIX = 'lh-media:';
export const LEARNING_HUB_ROUTE_PREFIX = 'lh-route:';
export const LEARNING_HUB_INTERNAL_LINK_CLASS = 'lh-internal-link';
export const LEARNING_HUB_ANCHOR_LINK_CLASS = 'lh-anchor-link';
export const LEARNING_HUB_ANCHOR_TARGET_PREFIX = 'lh-id-';
export const LEARNING_HUB_MISSING_IMAGE_CLASS = 'lh-image-missing';
export const LEARNING_HUB_IMAGE_PLACEHOLDER_CLASS = 'lh-image-placeholder';

export const LEARNING_HUB_CONFIG = new InjectionToken<LearningHubConfig>('LEARNING_HUB_CONFIG', {
  providedIn: 'root',
  factory: (): LearningHubConfig => ({
    ...environment.learningHub,
    mediaBaseUrl: environment.learningHubMediaBaseUrl
  })
});

export const LEARNING_HUB_MODULE_PATH = environment.modules.learningHub;

/** Child routes of the module (see learning-hub.routing.ts). */
export const LEARNING_HUB_SEARCH_PATH = 'search';
export const LEARNING_HUB_CATEGORY_PATH = 'category';
/** Same i18n files the app loads with TranslateHttpLoader (src/app/translate-application.module.ts). */
export const LEARNING_HUB_I18N_URL = './assets/i18n/';
